<template>
  <div id="app" v-on:click="greet">
    <ts-header
      v-if="gid"
      :showLogo="showLogo"
      :userInfo="userInfo"
      :gid="gid"
      :areaname="areaname"
    ></ts-header>
    <div v-if="showBlank" class="load__main"></div>
    <template v-else>
      <div class="page">
        <div :class="['container', showLeft ? '' : 'container-other']">
          <left-menu v-if="showLeft && gid" :gid="gid"></left-menu>
          <router-view />
        </div>
        <div
          class="float__right"
          :style="styleData"
          v-if="gid != 0 ? true : false"
        >
          <div class="float__bottom" v-show="play">
            <img src="./assets/images/touxiang.jpg" class="float__bottom-img" />
            <div class="float__bottom-name">
              HI，我是您的专属客服小但，微信扫一扫即可添加我为好友
            </div>
            <img src="./assets/images/kefuma.jpg" alt="" class="kefuma" />
            <i></i>
          </div>
          <img
            src="./assets/images/service.png"
            alt=""
            class="kefu"
            @click.stop="toggle"
          />
        </div>
      </div>
    </template>
    <ts-footer></ts-footer>
  </div>
</template>
<script>
import tsHeader from "./components/header";
import tsFooter from "./components/footer";
import leftMenu from "./components/left";
import { site } from "./utils/site";
import { ucIndex } from "./webapi/api";
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload,
      getUserInfo: this.getUserInfo,
    };
  },
  components: {
    tsHeader,
    tsFooter,
    leftMenu,
  },

  data() {
    return {
      play: false,
      showLogo: true,
      showBlank: true, // 是否显示初始化空白页
      showLeft: true, // 是否显示左边导航
      userInfo: {}, // 用户信息
      areaname: "", // 定位地址
      gid: null,
      styleData: {
        left: "",
      },
    };
  },

  mounted() {
    this.reload();
    this.lvs();
    this.getUserInfo();
  },

  methods: {
    reload() {
      let windowUrl = window.location.hash;
      if (
        windowUrl.indexOf("set/elaw") > -1 ||
        windowUrl.indexOf("/consumer") > -1
      ) {
        // 律师主页设置个人信息
        this.showLeft = false;
        this.showLogo = windowUrl.indexOf("set/elaw") > -1 ? false : true;
      } else {
        this.showLeft = true;
      }
    },

    // 请求用户信息
    getUserInfo() {
      this.$fetch
        .fetchData({
          url: ucIndex,
        })
        .then((res) => {
          let { data } = res;
          let { gid, info, areaname } = data || {};
          this.userInfo = info;
          this.areaname = areaname.replace("市", "");
          this.gid = gid;
          this.showBlank = false;
        })
        .catch((e) => {
          this.toast(e.errMsg || "请求错误");
          setTimeout(()=>{
             window.location.href = site.uc.url() + 'pub/wlogin'
          },2000)
         
        });
    },

    toast(msg) {
      this.$message({
        type: "error",
        showClose: true,
        message: msg,
        offset: 50,
      });
    },
    //专属客服
    lvs() {
      let windowWidth = document.body.clientWidth;
      let halfWidth = (windowWidth - 1200) / 2;
      console.log(windowWidth, halfWidth);
      this.styleData.left = halfWidth + 1200 + 154 - 140 + "px";
    },
    toggle() {
      this.play = !this.play;
    },
    greet() {
      this.play = false;
    },
  },
};
</script>

<style>
@import "./assets/css/iconfont.css";
/* 公共样式 */
html,
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
code,
form,
input,
textarea,
p,
th,
td,
tr,
button {
  margin: 0;
  padding: 0;
}
em,
th,
i {
  font-style: normal;
  font-weight: normal;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: normal;
}
ol,
ul,
li {
  list-style: none;
}
img {
  border: 0;
  vertical-align: top;
}
html {
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
}
a,
input,
button,
textarea {
  outline: none;
}
a {
  outline: none;
  text-decoration: none;
}
input {
  border: none;
  background-color: #fff;
}
textarea {
  resize: none;
}
button {
  cursor: pointer;
  background: none;
  border: 0;
  vertical-align: top;
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
  color: #c1c1c1 !important;
}
/*滚动条样式*/
::-webkit-scrollbar/*整体部分*/ {
  width: 8px;
  height: 10px;
}
::-webkit-scrollbar-track/*滑动轨道*/ {
  background: #eee;
  border-radius: 12px;
  -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0);
  box-shadow: inset 0 0 2px rgba(0, 0, 0, 0);
}
::-webkit-scrollbar-thumb/*滑块*/ {
  border-radius: 3px;
  background: #ccc;
}
::-webkit-scrollbar-thumb:hover/*滑块效果*/ {
  border-radius: 3px;
  background: #2da3df;
}

html,
body {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  font-size: 16px;
  color: #333;
}
#app {
  font-family: Microsoft YaHei, Heiti SC, tahoma, arial, Hiragino Sans GB,
    "\5B8B\4F53", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.load__main {
  position: relative;
  width: 1200px;
  height: 744px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.container {
  width: 1200px;
  height: 100%;
  margin: 0 auto 30px;
  display: flex;
  justify-content: space-between;
}

.container-other {
  width: 100%;
  margin-bottom: 0;
}
.home {
  position: relative;
}
.loading-wrap {
  min-height: 504px;
  height: 100%;
}

.float__l {
  float: left;
}

.float__r {
  float: right;
}
.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.border-bt {
  border-bottom: solid 1px #f5f5f5;
}

::placeholder {
  color: #999;
  font-size: 14px;
}
.ellipsis1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ellipsis2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ellipsis3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.clearfix {
  display: inline-table;
  display: block;
  zoom: 1;
}
.clearfix:after {
  content: "";
  clear: both;
  display: block;
  height: 0;
  visibility: hidden;
}

.clear {
  zoom: 1;
  clear: both;
}
.clear:after,
.clear:before {
  content: "";
  display: table;
}

.clear:after {
  clear: both;
  overflow: hidden;
}

/* elementui全局样式 */
.el-button--primary {
  background-color: #1476f9 !important;
  border-color: #1476f9 !important;
}
.el-button--primary:hover {
  background: rgba(20 118 249 / 70%) !important;
  border-color: #5a9ffb !important;
}
.el-tabs__active-bar {
  background-color: #1476f9 !important;
}
.el-tabs__item.is-active,
.el-tabs__item:hover {
  color: #1476f9 !important;
}
.el-switch.is-checked .el-switch__core {
  border-color: #1476f9 !important;
  background-color: #1476f9 !important;
}
.el-pager li.btn-quicknext,
.el-pager li.btn-quickprev {
  width: auto !important;
}
.el-input--mini .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
}
.el-button--mini,
.el-button--mini.is-round {
  padding: 9px 15px !important;
}

.el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus {
  border-color: #1476f9 !important;
}

.el-select-dropdown__item.selected {
  color: #1476f9 !important;
}

.el-input.is-active .el-input__inner,
.el-input__inner:focus {
  border-color: #1476f9 !important;
}

.el-form-item--mini .el-form-item__label {
  line-height: 32px !important;
}

.el-date-table td.today span {
  color: #1476f9 !important;
}

.el-date-table td.current:not(.disabled) span {
  background-color: #1476f9 !important;
}

.el-date-table td:hover {
  color: #1476f9 !important;
}

.el-pager li.active {
  color: #1476f9 !important;
}

.el-pagination .el-select .el-input .el-input__inner:hover {
  border-color: #1476f9 !important;
}

.el-pager li:hover {
  color: #1476f9 !important;
}

.el-pagination .btn-next:hover,
.el-pagination .btn-prev:hover {
  color: #1476f9 !important;
}

.el-pager li.btn-quicknext:hover,
.el-pager li.btn-quickprev:hover {
  color: #1476f9 !important;
}

.el-pagination .btn-next:disabled:hover,
.el-pagination .btn-prev:disabled:hover {
  color: #c0c4cc !important;
}

.el-textarea__inner:focus {
  border-color: #1476f9 !important;
}

.load {
  border-top-color: #1476f9 !important;
}

.distpicker-address-wrapper select {
  padding: 0 10px !important;
  height: 32px !important;
  font-size: 15px !important;
  line-height: 32px !important;
  outline: none !important;
  min-width: 100px !important;
  color: #606266 !important;
  width: 180px !important;
}

.distpicker-address-wrapper label {
  margin-right: 10px;
}

.el-button--medium {
  padding: 8px 20px !important;
}

.el-input--medium .el-input__inner {
  height: 32px !important;
  line-height: 32px !important;
}

.el-input--medium .el-input__icon {
  line-height: 32px !important;
}

.el-radio {
  line-height: 32px;
}

.el-tag--medium {
  height: 32px !important;
  line-height: 30px !important;
  margin-right: 10px;
  margin-bottom: 10px;
  cursor: pointer;
}

.el-tag--plain {
  color: #1476f9 !important;
  border-color: #1476f9 !important;
  font-size: 14px;
}

.el-tag--dark {
  background-color: #1476f9 !important;
  border-color: #1476f9 !important;
}

.el-tag--plain .el-tag__close {
  color: #1476f9 !important;
}

.el-tag--plain .el-tag__close:hover {
  color: #fff !important;
  background: #1476f9 !important;
}

.el-dialog {
  border-radius: 8px !important;
}

.el-dialog__header {
  padding: 0 !important;
  background-color: #fff !important;
  height: 32px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}

.el-dialog__title {
  line-height: 32px !important;
  color: #999 !important;
  font-size: 12px !important;
  font-weight: normal;
  margin-left: 20px;
}

.el-dialog__headerbtn {
  right: 16px !important;
  top: 8px !important;
}

/* .el-alert--warning.is-light {
  background-color: #ffe58f !important;
} */

.el-alert {
  line-height: 0;
}

.el-badge__content {
  background-color: #e84026 !important;
}

.el-badge__content.is-fixed.is-dot {
  right: 1px !important;
  top: -5px !important;
}

.el-rate {
  height: auto !important;
}

.all__pingfen .el-rate__icon {
  font-size: 28px;
}

.float__right {
  width: 66px;
  height: 66px;
  position: fixed;
  top: 506px;
  /* width: 200px; */
  z-index: 1000;
}
.float__right .kefu {
  width: 66px;
  height: 66px;
  position: absolute;
  right: 0;
  bottom: 0;
}
.float__bottom {
  position: absolute;
  top: -264px;
  left: 6px;
  padding: 44px 25px 32px;
  position: relative;
  width: 200px;
  background: #fff;
  border-radius: 5px;
  box-sizing: border-box;
  -webkit-box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
}
.float__bottom i {
  position: absolute;
  bottom: -6px;
  left: 80%;
  margin-left: -8px;
  width: 16px;
  height: 20px;
  background-color: #fff;
  transform: rotate(45deg);
}
.float__bottom .kefuma {
  width: 100px;
  height: 100px;
  margin-top: 20px;
  margin-left: 25px;
}

.float__bottom-img {
  padding: 3px;
  background-color: #fff;
  width: 62px;
  height: 62px;
  position: absolute;
  top: -36px;
  left: 50%;
  margin-left: -31px;
  border-radius: 50%;
  -webkit-box-shadow: 0 3px 3px rgb(0 0 0 / 10%);
  -moz-box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
  box-shadow: 0 3px 3px rgb(0 0 0 / 10%);
  box-sizing: border-box;
}

.live__alert {
  width: 320px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue